import moment from 'moment'
import 'moment/locale/ru'

export const TIME_FORMAT = process.env.REACT_APP_TIMEFORMAT

export const getCurrentPrice = (prices) => {
  const currentTime = Date.now() / 1000

  return prices?.find((p) => {
    const startDate = typeof p?.start_date === 'string' ? Date.parse(p?.start_date) / 1000 : p?.start_date

    return currentTime < startDate
  })
}

export const getFormatTime = (time, timezone, format = 'DD.MM.YYYY') => {
  let timeTz = unixToMoment(time)

  if (timezone) {
    timeTz = unixToMoment(time).tz(timezone)
  }
  return `${timeTz.format(format)}`
}

export const unixToMoment = (timestamp) => {
  if (TIME_FORMAT === 'timestamp') {
    return moment.unix(timestamp)
  } else if (TIME_FORMAT === 'iso') {
    return moment.utc(timestamp)
  }

  return moment(timestamp) // default ISO
}

/**
 * Конвертирует миллисекунды в строку времени.
 *
 * @param {number} ms - количество миллисекунд
 * @param {string} format - формат вывода: 'HH:MM:SS', 'MM:SS', или 'auto' (по умолчанию)
 * @returns {string|null} строка времени или null при ошибке
 */
export function msToTimeStr(ms, format = 'auto') {
  // Проверяем, что входной параметр - число и не отрицательное
  if (typeof ms !== 'number' || isNaN(ms) || ms < 0) {
    return null
  }

  try {
    // Конвертируем миллисекунды в секунды
    const totalSeconds = Math.floor(ms / 1000)

    // Вычисляем часы, минуты и секунды
    const hours = Math.floor(totalSeconds / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60

    // Форматируем числа с ведущими нулями
    const formatNumber = (num) => num.toString().padStart(2, '0')

    switch (format) {
      case 'HH:MM:SS':
        return `${formatNumber(hours)}:${formatNumber(minutes)}:${formatNumber(seconds)}`

      case 'MM:SS':
        // Конвертируем часы в минуты
        const totalMinutes = hours * 60 + minutes
        return `${formatNumber(totalMinutes)}:${formatNumber(seconds)}`

      case 'SS':
        return totalSeconds.toString()

      case 'auto':
      default:
        // Автоматически выбираем формат в зависимости от значения
        if (hours > 0) {
          return `${formatNumber(hours)}:${formatNumber(minutes)}:${formatNumber(seconds)}`
        } else if (minutes > 0) {
          return `${formatNumber(minutes)}:${formatNumber(seconds)}`
        } else {
          return seconds.toString()
        }
    }
  } catch (error) {
    return null
  }
}
